export const shortMailName = (name: string) => {
  if (!name) {
    return "??";
  }
  const names = name.split(" ");
  return names.length > 1
    ? names[0].charAt(0) + names[1].charAt(1)
    : names[0].charAt(0) + names[0].charAt(1);
};
